import { useContext, useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { default as acabadosBanner, default as arrendamientoBanner } from "../../../assets/acabadosBanner.png";
import asesorFinancieroBanner from "../../../assets/asesorFinancieroBanner.png";
import ahorrosBanner from "../../../assets/banner-ahorrar.jpg";
import creditoBancolombiaBanner from "../../../assets/banner-credito-bancolombia.png";
import creditoComfamaBanner from "../../../assets/banner-credito-comfama.png";
import deudasBanner from "../../../assets/banner-deudas.jpg";
import estudiarBanner from "../../../assets/banner-estudiar.jpg";
import ingresosEstablesBanner from "../../../assets/banner-ingresos-estables.png";
import mentoriaTalentoBanner from "../../../assets/banner-mentoria-talento.png";
import otroBanner from "../../../assets/banner-otro.jpg";
import vestaBanner from "../../../assets/banner-vesta.png";
import viajarBanner from "../../../assets/banner-viajar.jpg";
import { default as mentoriaFinancieraPagaBanner, default as viviendaBanner } from "../../../assets/banner-vivienda.jpg";
import caminoMiCasaBanner from "../../../assets/bg-banner-camino-a-mi-casa-desktop.png";
import medalExplorador from "../../../assets/medal-explorador.svg";


import {
  getDataTreatment,
  getInitialResults
} from "../../../services/mentoriaService";
import Loader from "../../../shared/src/components/atoms/loader/loader";
import Modal from "../../../shared/src/components/molecules/modal/modal";
import MedalModal from "../../../shared/src/components/organisms/medal-modal/MedalModal";
import authContext from "../../../shared/src/contexts/authContext";
import PurposeBanner from "../../molecules/purpose-banner/purposeBanner";
import ResultCard from "../../molecules/result-card/resultCard";
import BannerDirigido from "../banner/BannerDirigido";
import ModalContinuarDiagnosticoCompleto from "../modal-content/modal-continuar-diagnostico-completo/modalContinuarDiagnosticoCompleto";
import "./diagnosticoPartialResult.scss";

const DiagnosticoPartialResult = () => {
  const context = useContext(authContext);
  const [results, setResults] = useState<any|any>(null);
  const [loading, setLoading] = useState(true);
  const [destiny, setDestiny] = useState<number>(0);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  
  
  const navigateFinal = () => {
    navigate("/formulario-salud-educacion-financiera/");
  };


  const purposesBanners = useMemo(
    () => ({
      "30": {
        title: "¡Gracias por compartirnos tu propósito!",
        description:
          "Queremos ayudarte a alcanzar todo lo que deseas, por eso te invitamos a participar en la Mentoría Financiera Comfama para que estés mas cerca de tu propósito de vivienda.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: viviendaBanner,
        onClick: navigateFinal,
        yPosition: "20%",
      },
      "31": {
        title: "¡Felicitaciones!",
        description:
          "Has dado el primer paso para lograr tu proyecto educativo, continúa realizando el diagnóstico financiero para enfocar tu solución.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: estudiarBanner,
        onClick: navigateFinal,
        yPosition: "92%",
      },
      "32": {
        title: "¡Felicitaciones!",
        description:
          "Has dado el primer paso para lograr tu viaje soñado, continúa realizando el diagnóstico financiero para enfocar tu solución.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: viajarBanner,
        onClick: navigateFinal,
        yPosition: "63%",
      },
      "34": {
        title: "¡Felicitaciones!",
        description:
          "Has dado el primer paso para salir de deudas, continúa realizando el diagnóstico financiero para enfocar tu solución.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: deudasBanner,
        onClick: navigateFinal,
        yPosition: "20%",
      },
      "35": {
        title: "¡Felicitaciones!",
        description:
          "Has dado el primer paso para consolidar tu ahorro, continúa realizando el diagnóstico financiero para enfocar tu solución.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: ahorrosBanner,
        onClick: navigateFinal,
        yPosition: "75%",
      },
      "33": {
        title: "¡Felicitaciones!",
        description:
          "Has dado el primer paso para consolidar tu ingreso estable, continúa realizando el diagnóstico financiero para enfocar tu solución.",
        buttonText: "Completa tu diagnóstico",
        backgroundImage: ingresosEstablesBanner,
        onClick: navigateFinal,
        yPosition: "50%",
      },
      "81": {
        title: "¡Felicitaciones!",
        description: `¡Este es el primer paso para tu propósito${
          results && results.purposePrincipal.name
            ? " de " + results.purposePrincipal.name
            : ""
        }! Continúa realizando el diagnóstico financiero para enfocar tu solución.`,
        buttonText: "Completa tu diagnóstico",
        backgroundImage: otroBanner,
        onClick: navigateFinal,
        yPosition: "10%",
      },
    }),
    [results]
  );

  const getResults = async () => {
    if (authContext) {
      const dataTreatment = await getDataTreatment();

      if (!dataTreatment.data.data) {
        navigate("/formulario-inicial/");
        return;
      }

        const resultsRes = await getInitialResults();

      if (resultsRes.data.status === 500) {
        navigate("/formulario-inicial/");
        return;
      }
      if(resultsRes.data.data !== null){
        setResults(resultsRes.data.data);
      }
      setLoading(false);
    }
  };
  
  const renderBanner = () => {
    switch(destiny){
      case 1:
        return(
          <BannerDirigido
            title="¡Felicitaciones!"
            text="Cumples con los requisitos para unirte a Camino a Mi Casa. Prepárate, uno de nuestros asesores te llamará muy pronto."
            imagen={caminoMiCasaBanner}
            textButon="Más información"
            urlBotonAlterno="https://www.comfama.com/finanzas/ahorro-con-proposito/camino-a-mi-casa/"
            mentoria={true}
          />);
      case 2:
        return(
        <BannerDirigido
          title="¡Gracias por confiar en nosotros y compartir tu propósito!"
          text="Estamos aquí para ayudarte a alcanzar tus metas. Prepárate, uno de nuestros asesores te llamará pronto para que inicies tu Mentoría Financiera."
          imagen={viviendaBanner}
          textButon="Completa tu diagnóstico"
        />);
      case 3:
        return(
          <BannerDirigido 
            title="¡Gracias por compartirnos tu propósito!"
            text="Estamos listos para acompañarte a cumplirlo.  Un asesor financiero de Comfama te contactará en los próximos días para apoyarte en hacerlo realidad."
            imagen={asesorFinancieroBanner}
            />);
      case 4:
        return(
        <BannerDirigido 
          title="¡Felicitaciones!"
          text="Has completado la información necesaria para formar parte de la Mentoría de Talento. En los próximos días, nos pondremos en contacto contigo."
          imagen={mentoriaTalentoBanner}
          />);
      case 5:
          return(
          <BannerDirigido 
            title="¡Felicitaciones!" 
            text="Estas más cerca de lograr tu propósito con nuestro aliado experto en comprar vivienda Vesta. Una de las gestoras te contactará en los próximos días para acompañarte a hacer realidad tu sueño." 
            imagen={vestaBanner}      
          />);
      case 6:
        return(
        <BannerDirigido 
          title="¡Felicitaciones!"
          text="Has sido seleccionado para iniciar un estudio de crédito de vivienda con nuestro aliado Bancolombia."
          imagen={creditoBancolombiaBanner}
          textButon="Conocer el crédito"
          urlBotonAlterno="https://qa.comfama.com/mentoria-financiera/credito-hipotecario-bancolombia/"
          />);
      case 7:
        return(
        <BannerDirigido 
          title="¡Gracias por confiar en nosotros y compartir tu propósito!"
          text="Queremos acompañarte en el camino hacia tu propósito, por eso te invitamos a unirte a la Mentoría Financiera Comfama."
          imagen={mentoriaFinancieraPagaBanner}
          textButon="Comprar Mentoría"
          urlBotonAlterno="https://tienda.comfama.com/mentoria-financiera-personalizada/p"
          />);
      case 8:
        return(
        <BannerDirigido 
          title="¡Gracias por permitirnos ser parte de tu propósito!" 
          text="Un analista de crédito de Comfama te contactará en los próximos días para ayudarte a hacerlo realidad." 
          imagen={creditoComfamaBanner}
          />);
      case 9:
        return(<BannerDirigido
          title="¡Nos inspira tu propósito!" 
          text="Estamos listos para ayudarte a hacer realidad tus deseos. Eres un posible candidato para un crédito de mejoramiento de vivienda, así que un analista de crédito se comunicará contigo en los próximos días para brindarte la guía necesaria." 
          imagen={creditoComfamaBanner}
          />);
      case 10:
        return(<BannerDirigido 
          title="¡Nos encanta conocer tu propósito!" 
          text="Estamos listos para acompañarte a cumplirlo. Un analista de Comfama te contactará en los próximos días para apoyarte en hacerlos realidad." 
          imagen={acabadosBanner}/>);
      case 11:
        return(
        <BannerDirigido 
          title="¡Nos encanta conocer tu propósito! "
          text="Estamos aquí para ayudarte a lograr tus objetivos. Eres un posible candidato para un subsidio de construcción de vivienda, da clic en el botón y conoce el subsidio." 
          imagen={creditoBancolombiaBanner}
          textButon="Conocer el subsidio"
          urlBotonAlterno="https://www.comfama.com/subsidio/subsidio-de-vivienda/mejoramiento-y-construccion-sitio-propio/"
          />);
      case 12:
        return(
          <BannerDirigido 
            title="¡Nos encanta conocer tu propósito!"
            text="Queremos acompañarte a cumplirlo. Un analista de Comfama te contactará para ayudarte a hacer realidad tu meta."
            imagen={arrendamientoBanner}/>
        );
      case 13:
        return(
          <BannerDirigido
            title="¡Felicitaciones!"
            text="Cumples con los requisitos para unirte a Camino a Mi Casa. Prepárate, uno de nuestros asesores te llamará muy pronto."
            imagen={caminoMiCasaBanner}
            textButon="Más información"
            urlBotonAlterno="https://www.comfama.com/finanzas/ahorro-con-proposito/camino-a-mi-casa/"
            mentoria={true}
          />);
      case 14:
      case 15:
        return(
        <BannerDirigido
          title="¡Gracias por confiar en nosotros y compartir tu propósito!"
          text="Estamos aquí para ayudarte a alcanzar tus metas. Prepárate, uno de nuestros asesores te llamará pronto para que inicies tu Mentoría Financiera."
          imagen={viviendaBanner}
          textButon="Completa tu diagnóstico"
        />);
      default:
        return(
          <PurposeBanner
            title={purposesBanners[results.purposePrincipal.id].title}
            description={purposesBanners[results.purposePrincipal.id].description}
            buttonText={purposesBanners[results.purposePrincipal.id].buttonText}
            backgroundImage={
              purposesBanners[results.purposePrincipal.id].backgroundImage
            }
            onClick={navigateFinal}
            yPosition={purposesBanners[results.purposePrincipal.id].yPosition}
          />
        );
    }
  };

  
  useEffect(()=>{
    setDestiny(results?.destination.id);
  },[results]);

  useEffect(() => {
    if (context.gigyaAccount) getResults();
  }, [context]);

  if (loading) {
    return <Loader />;
  }


  return (
    <div className="partial-result">
      <Modal
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
      >
        <ModalContinuarDiagnosticoCompleto />
      </Modal>
      {createPortal(
        <MedalModal>
          <MedalModal.Icon
            element={
              <img
                className="medal-modal__icon"
                src={medalExplorador}
                alt="Medalla Explorador"
              />
            }
          />
          <MedalModal.Title>¡Felicidades!</MedalModal.Title>
          <p>
            <b>¡Desbloqueaste la medalla Explorador financiero!</b>
          </p>
          <p>
            Hemos tenido el privilegio de conocerte un poco más, avanza con
            confianza en tu viaje hacia una transformación financiera.
          </p>
        </MedalModal>,
        document.body
      )}
      <header>
        <h1>¡En Comfama pensamos en ti!</h1>
        <h2>
          Es por esto que te compartimos algunas oportunidades para que mejores
          tu salud financiera
        </h2>
      </header>
      <main className="partial-result__cards">
        {results &&
          results.indicators.map((indicator, idx) => {

            if (idx === 0) {
              let calculateScore;

              if (indicator.value <= 0) {
                calculateScore = "bad";
              } else if (indicator.value <= 10) {
                calculateScore = "medium";
              } else {
                calculateScore = "good";
              }

              return (
                <ResultCard
                  key={indicator.name}
                  title={indicator.name}
                  description={indicator.description}
                  score={calculateScore}
                ></ResultCard>
              );
            }

            if (idx === 1) {
              let calculateScore;

              if (indicator.value < 2) {
                calculateScore = "bad";
              } else if (indicator.value < 4) {
                calculateScore = "medium";
              } else {
                calculateScore = "good";
              }

              return (
                <ResultCard
                  key={indicator.name}
                  title={indicator.name}
                  description={indicator.description}
                  score={calculateScore}
                ></ResultCard>
              );
            }

            if (idx === 2) {
              let calculateScore;

              if (indicator.value > 35) {
                calculateScore = "bad";
              } else if (indicator.value > 20) {
                calculateScore = "medium";
              } else {
                calculateScore = "good";
              }

              return (
                <ResultCard
                  key={indicator.name}
                  title={indicator.name}
                  description={indicator.description}
                  score={calculateScore}
                ></ResultCard>
              );
            }

            if (idx === 3) {
              let calculateScore;

              if (indicator.value <= 0) {
                calculateScore = "bad";
              } else if (indicator.value <= 10) {
                calculateScore = "medium";
              } else {
                calculateScore = "good";
              }

              return (
                <ResultCard
                  key={indicator.name}
                  title={indicator.name}
                  description={indicator.description}
                  score={calculateScore}
                ></ResultCard>
              );
            }
            return <></>;
          })}
      </main>
      {renderBanner()}
    </div>
  );
};
export default DiagnosticoPartialResult;